module.exports = __webpack_public_path__ + "media/images/marketing/spiral_up_phone-e384ea8c8e549edd615fd8e6a910c7bbe6f0bdbf1099578f838cc67a28daf871.png";